import { Navigate, useSearchParams } from "react-router-dom";

export default function BillingRedirect({ type }) {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.set("billing", type);
  return <Navigate to={`/userprofile?${params.toString()}`} replace />;
}
